import React, { useEffect, useState } from "react";

import {
  Box,
  Paper,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Typography,
  Button,
  Chip,
  Alert,
  
  Dialog,
   Radio,
  RadioGroup,
  FormControlLabel,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import axiosApi from "../Utils/axiosApi";
import DailyMessDetailsDialog from "./DailyMessDetailsDialog";
import dayjs from "dayjs";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

const GuestEntryCard = ({
  index,
  row,
  roomTypes,
  hostelRoomDTOs = [], // ADD THIS LINE
  rows,
   hostelId, // Add this
  handleChange,
  handleSaveRow,
  handlePrint,
  handleWhatsApp,
  setRows,
  setRowToDelete,
  setOpenDeleteDialog,
    isReadOnly = false,
  isDateOnlyEdit = false,
  isFullOccupancyEdit = false,
  showPrintActions = true,
  showWhatsAppActions = true,
  showDeleteActions = true,
}) => {
  const [openMessDetails, setOpenMessDetails] =
    useState(false);

  const [loadingMessDetails, setLoadingMessDetails] =
    useState(false);
  const [openGuestDetails, setOpenGuestDetails] = useState(false);
  const [guestDetails, setGuestDetails] = useState([]);
  const [guestDetailsError, setGuestDetailsError] = useState("");
  const [loadingGuestDetails, setLoadingGuestDetails] = useState(false);
const [openRoomSearch, setOpenRoomSearch] = useState(false);
const [availableRooms, setAvailableRooms] = useState([]);
const [loadingRooms, setLoadingRooms] = useState(false);
const [roomSearchError, setRoomSearchError] = useState("");
const [openRentDialog, setOpenRentDialog] = useState(false);
const [selectedRoomNumber, setSelectedRoomNumber] = useState("");
const [selectedRentPlan, setSelectedRentPlan] = useState("");
const [manualRoomRent, setManualRoomRent] = useState("");
const [rentDialogRoomType, setRentDialogRoomType] = useState("");
  /* =====================================================
     SERVICE
  ===================================================== */
const canEditDates =
  !isReadOnly && Boolean(row.isEditing);

const canEditOtherFields =
  !isReadOnly &&
  Boolean(row.isEditing) &&
  !isDateOnlyEdit;

const canSave =
  !isReadOnly && Boolean(row.isEditing);
  
  const hasMess =
    row.serviceType === "mess" ||
    row.serviceType === "both";

  const hasStay =
    row.serviceType === "stay" ||
    row.serviceType === "both";

  /* =====================================================
     PROPERTY TYPE
  ===================================================== */

  const propertyType = String(
    row.propertyType ||
      row.property ||
      row.hostelPropertyType ||
      ""
  )
    .trim()
    .toLowerCase();

  const isMicroStay =
    propertyType === "micro stay" ||
    propertyType === "microstay" ||
    propertyType === "micro-stay";

  /* =====================================================
     STATUS
  ===================================================== */

  const statusLabel = (status) => {
    if (
      status === "paid" ||
      status === "completed"
    ) {
      return "Completed";
    }

    if (
      status === "partial" ||
      status === "partially_completed"
    ) {
      return "Partial";
    }

    return "Pending";
  };

  const statusColor = (status) => {
    if (
      status === "paid" ||
      status === "completed"
    ) {
      return "success";
    }

    if (
      status === "partial" ||
      status === "partially_completed"
    ) {
      return "warning";
    }

    return "default";
  };

  /* =====================================================
     TOTALS
  ===================================================== */

  const calculatedTotal =
    Number(row.total ?? 0);

  const isFinalBillEmpty =
    row.finalBill === undefined ||
    row.finalBill === null ||
    row.finalBill === "";

  const finalBill =
    isFinalBillEmpty ||
    Number(row.finalBill) === 0
      ? calculatedTotal
      : Number(row.finalBill);

  const isManualFinalBill =
    !isFinalBillEmpty &&
    Number(finalBill) !==
      calculatedTotal;

  /* =====================================================
     INITIAL FINAL BILL
  ===================================================== */

  useEffect(() => {
    if (!canEditOtherFields) {
      return;
    }

    const hasFinalBill =
      row.finalBill !== undefined &&
      row.finalBill !== null &&
      row.finalBill !== "" &&
      Number(row.finalBill) > 0;

    if (
      hasFinalBill ||
      calculatedTotal <= 0
    ) {
      return;
    }

    setRows((prevRows) =>
      prevRows.map((item, i) =>
        i === index &&
        (
          item.finalBill === undefined ||
          item.finalBill === null ||
          item.finalBill === "" ||
          Number(item.finalBill) === 0
        )
          ? {
              ...item,
              finalBill:
                calculatedTotal,
            }
          : item
      )
    );
  }, [
  canEditOtherFields,
  row.finalBill,
  calculatedTotal,
  index,
  setRows,
]);

  /* =====================================================
     DAILY MESS DETAILS
  ===================================================== */

  const handleOpenMessDetails =
    async () => {
      if (row?.id) {
        try {
          setLoadingMessDetails(true);

         const currentHostelId =
  hostelId ?? row.hostelId ?? row.hostel?.id ?? null;

if (currentHostelId == null || currentHostelId === "") {
  throw new Error("Hostel ID is missing.");
}

const response = await axiosApi.post(
  "/stayServiceBooking/getDailyMealRecord",
  {
    stayServiceBookingId: Number(row.id),
    hostelId: Number(currentHostelId),
  }
);

          const responseData =
            response?.data;

          let backendDetails = [];

          if (
            Array.isArray(
              responseData
            )
          ) {
            backendDetails =
              responseData;
          } else if (
            Array.isArray(
              responseData?.data
            )
          ) {
            backendDetails =
              responseData.data;
          } else if (
            Array.isArray(
              responseData?.shortStayMealDaily
            )
          ) {
            backendDetails =
              responseData.shortStayMealDaily;
          } else if (
            Array.isArray(
              responseData?.shortStayMealDailyDTOs
            )
          ) {
            backendDetails =
              responseData.shortStayMealDailyDTOs;
          }

          const details =
            backendDetails.map(
              (item) => {
                const breakfast = {
                  selected:
                    item.breakfastSelected ===
                    true,

                  qty: Number(
                    item.breakfastQty ??
                      0
                  ),

                  childQty:
                    Number(
                      item.breakfastChildQty ??
                        0
                    ),

                  amount:
                    Number(
                      item.breakfastAmount ??
                        0
                    ),
                };

                const lunch = {
                  selected:
                    item.lunchSelected ===
                    true,

                  qty: Number(
                    item.lunchQty ??
                      0
                  ),

                  childQty:
                    Number(
                      item.lunchChildQty ??
                        0
                    ),

                  amount:
                    Number(
                      item.lunchAmount ??
                        0
                    ),
                };

                const dinner = {
                  selected:
                    item.dinnerSelected ===
                    true,

                  qty: Number(
                    item.dinnerQty ??
                      0
                  ),

                  childQty:
                    Number(
                      item.dinnerChildQty ??
                        0
                    ),

                  amount:
                    Number(
                      item.dinnerAmount ??
                        0
                    ),
                };

                const extraMeal =
                  item.extraMeal ??
                  "";

                const extraAmount =
                  Number(
                    item.extraAmount ??
                      0
                  );

                const totalAmount =
                  (
                    breakfast.selected
                      ? breakfast.amount
                      : 0
                  ) +
                  (
                    lunch.selected
                      ? lunch.amount
                      : 0
                  ) +
                  (
                    dinner.selected
                      ? dinner.amount
                      : 0
                  ) +
                  extraAmount;

                return {
                  id:
                    item.id ??
                    null,

                  date:
                    item.mealDate
                      ? String(
                          item.mealDate
                        ).substring(
                          0,
                          10
                        )
                      : "",

                  mealDate:
                    item.mealDate ??
                    null,

                  hostelId:
                    item.hostelId ??
                    row.hostelId ??
                    null,

                  breakfast,
                  lunch,
                  dinner,

                  extraMeal,
                  extraAmount,
                  totalAmount,
                };
              }
            );

          setRows((prevRows) =>
            prevRows.map(
              (item, i) =>
                i === index
                  ? {
                      ...item,
                      dailyMessDetails:
                        details,
                      errorMsg: "",
                      successMsg: "",
                    }
                  : item
            )
          );

          setOpenMessDetails(true);
        } catch (error) {
          console.error(
            "Get Daily Mess Details error:",
            error
          );

          setRows((prevRows) =>
            prevRows.map(
              (item, i) =>
                i === index
                  ? {
                      ...item,
                      errorMsg:
                        "Failed to load Daily Mess Details",
                      successMsg: "",
                    }
                  : item
            )
          );
        } finally {
          setLoadingMessDetails(false);
        }

        return;
      }

      setOpenMessDetails(true);
    };
const handleSearchAvailableRooms = async () => {
  // Validate check-in and check-out dates
  if (!row.checkIn || !row.checkOut) {
    setRoomSearchError("Please select check-in and check-out dates.");
    return;
  }

  const checkIn = dayjs(row.checkIn);
  const checkOut = dayjs(row.checkOut);

  if (!checkIn.isValid() || !checkOut.isValid()) {
    setRoomSearchError("Please select valid check-in and check-out dates.");
    return;
  }

  if (!checkOut.isAfter(checkIn)) {
    setRoomSearchError("Check-out date must be after check-in date.");
    return;
  }

  // Use the hostelId prop passed from the parent component
  const currentHostelId =
    hostelId ?? row.hostelId ?? row.hostel?.id ?? null;

  console.log("Hostel ID received by GuestEntryCard:", currentHostelId);
  console.log("Selected room type:", row.roomType);

  if (currentHostelId == null || currentHostelId === "") {
    setRoomSearchError(
      "Hostel ID is missing. Please select a property and try again."
    );
    return;
  }

  setLoadingRooms(true);
  setRoomSearchError("");
  setAvailableRooms([]);
  setOpenRoomSearch(true);

  try {
    const requestBody = {
      hostelSearchCriteria: {
        searchCheckInDate: checkIn.format("YYYY-MM-DDTHH:mm:ss"),
        searchCheckOutDate: checkOut.format("YYYY-MM-DDTHH:mm:ss"),
        roomType: row.roomType || "",
        propertyType:
          row.propertyType ||
          row.property ||
          row.hostelPropertyType ||
          "",
        hostelIds: [currentHostelId],
      },
    };

    console.log("Available rooms request:", requestBody);

    const response = await axiosApi.post(
      "/public/getAvailableHostelRooms",
      requestBody
    );

    console.log(
      "Available rooms API response:",
      response?.data
    );

    // Parse the API response
    const data = response?.data;

    const rooms = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
      ? data.data
      : Array.isArray(data?.availableRooms)
      ? data.availableRooms
      : [];

    // Filter results to the selected room type
    const selectedRoomType = String(row.roomType || "")
      .trim()
      .toLowerCase();

    const matchingRooms = rooms
      .filter((room) => {
        const responseRoomType = String(
          room.roomType ?? room.type ?? ""
        )
          .trim()
          .toLowerCase();

        return (
          !selectedRoomType ||
          responseRoomType === selectedRoomType
        );
      })
      .flatMap((room) => {
        // Extract actual room numbers returned by the backend
        const roomNumbers = String(
          room.roomNumber ?? room.roomNo ?? room.name ?? ""
        )
          .split(",")
          .map((number) => number.trim())
          .filter(Boolean);

        // When the backend returns actual room numbers
        if (roomNumbers.length > 0) {
          return roomNumbers.map((roomNumber, index) => ({
            ...room,
            id: `${room.id ?? room.roomId ?? "room"}-${index}`,
            roomNumber,
            roomNumbersNotProvided: false,
          }));
        }

        // When the backend provides an available count but no room numbers
        const availableCount = Number(
          room.availableRoomCount ?? 0
        );

        if (availableCount > 0) {
          return [
            {
              ...room,
              id: room.id ?? room.roomId ?? room.roomType,
              roomNumber: "",
              availableRoomCount: availableCount,
              roomNumbersNotProvided: true,
            },
          ];
        }

        return [];
      });

    console.log("Matching rooms:", matchingRooms);

    setAvailableRooms(matchingRooms);

    if (matchingRooms.length === 0) {
      setRoomSearchError(
        `No available rooms found for ${
          row.roomType || "the selected room type"
        } during the selected period.`
      );
    }
  } catch (error) {
    console.error("Error searching available rooms:", error);

    setRoomSearchError(
      error?.response?.data?.message ||
        error?.message ||
        "Failed to search available rooms. Please try again."
    );
  } finally {
    setLoadingRooms(false);
  }
};
  /* =====================================================
     SAVE DAILY MESS DETAILS
  ===================================================== */

  const handleSaveMessDetails =
    (details) => {
      const updatedDetails =
        details.map((detail) => ({
          ...detail,

          hostelId:
            detail.hostelId ??
            row.hostelId ??
            null,
        }));

      setRows((prevRows) =>
        prevRows.map((item, i) =>
          i === index
            ? {
                ...item,

                dailyMessDetails:
                  updatedDetails,

                isEditing: true,

                isSaved: false,

                errorMsg: "",

                successMsg: "",
              }
            : item
        )
      );

      setOpenMessDetails(false);
    };

  /* =====================================================
     GUEST DETAILS
  ===================================================== */

const handleOpenGuestDetails = async () => {
  setGuestDetailsError("");

  // NEW ENTRY: keep guest details locally until the bill is saved.
  if (!row.id) {
    setGuestDetails(
      row.guestDetails?.length
        ? row.guestDetails
        : [
            {
              guestName: row.name || "",
              age: "",
              phoneNumber: row.customerMobileNumber || "",
            },
          ]
    );

    setOpenGuestDetails(true);
    return;
  }

  // EXISTING ENTRY: load saved guest details from the backend.
  const currentHostelId =
    hostelId ?? row.hostelId ?? row.hostel?.id ?? null;

  if (currentHostelId == null || currentHostelId === "") {
    setGuestDetailsError("Hostel ID is missing.");
    setOpenGuestDetails(true);
    return;
  }

  setLoadingGuestDetails(true);

  try {
    const response = await axiosApi.post(
      "/stayServiceBooking/getGuestDetails",
      {
        stayServiceBookingId: Number(row.id),
        hostelId: Number(currentHostelId),
      }
    );

    const responseData = response?.data;

    const backendGuests = Array.isArray(responseData)
      ? responseData
      : Array.isArray(responseData?.data)
      ? responseData.data
      : [];

    const mappedGuests = backendGuests.map((guest) => ({
      ...guest,
      guestName: guest.guestName ?? guest.name ?? "",
      age: guest.age ?? "",
      phoneNumber:
        guest.phoneNumber ?? guest.mobileNumber ?? "",
    }));

    const guestsToShow = mappedGuests.length
      ? mappedGuests
      : [
          {
            guestName: row.name || "",
            age: "",
            phoneNumber: row.customerMobileNumber || "",
          },
        ];

    setGuestDetails(guestsToShow);

    setRows((prevRows) =>
      prevRows.map((item, i) =>
        i === index
          ? { ...item, guestDetails: guestsToShow }
          : item
      )
    );

    setOpenGuestDetails(true);
  } catch (error) {
    console.error("Get Guest Details error:", error);

    setGuestDetailsError(
      error?.response?.data?.message ||
        "Failed to load Guest Details."
    );

    setOpenGuestDetails(true);
  } finally {
    setLoadingGuestDetails(false);
  }
};

const handleSaveGuestDetails = () => {
  const cleanedGuests = guestDetails.map((guest) => ({
    ...guest,
    guestName: String(guest.guestName || "").trim(),
    age: guest.age === "" ? "" : Number(guest.age),
    phoneNumber: String(guest.phoneNumber || "")
      .replace(/\D/g, ""),
  }));

  const invalidGuest = cleanedGuests.some((guest) =>
    !guest.guestName ||
    guest.age === "" ||
    !Number.isFinite(Number(guest.age)) ||
    Number(guest.age) < 0 ||
    Number(guest.age) > 120 ||
    !/^\d{10}$/.test(guest.phoneNumber)
  );

  if (invalidGuest) {
    setGuestDetailsError(
      "Enter each guest's name, a valid age (0–120), and a 10-digit phone number."
    );
    return;
  }

  setRows((prevRows) =>
    prevRows.map((item, i) =>
      i === index
        ? {
            ...item,
            guestDetails: cleanedGuests,
            isEditing: true,
            isSaved: false,
            errorMsg: "",
            successMsg: "",
          }
        : item
    )
  );

  setGuestDetails(cleanedGuests);
  setGuestDetailsError("");
  setOpenGuestDetails(false);
};

  /* =====================================================
     EDIT
  ===================================================== */

  const handleEdit = () => {
    const updated = [...rows];

    updated[index] = {
      ...updated[index],

      finalBill:
        updated[index].finalBill !==
          undefined &&
        updated[index].finalBill !==
          null &&
        updated[index].finalBill !== "" &&
        Number(
          updated[index].finalBill
        ) > 0
          ? Number(
              updated[index].finalBill
            )
          : Number(
              updated[index].total ?? 0
            ),

      isEditing: true,

      isSaved: false,

      errorMsg: "",

      successMsg: "",
    };

    setRows(updated);
  };
console.log("hostelRoomDTOs received:", hostelRoomDTOs);
console.log("Selected room type:", row.roomType);

const handleRoomTypeChange = (selectedRoomType) => {
  handleChange(index, "roomType", selectedRoomType);
  handleChange(index, "roomNumber", "");
  handleChange(index, "roomRent", "");
  handleChange(index, "rentPlan", "");

  setRentDialogRoomType(selectedRoomType);
  setSelectedRoomNumber("");
  setSelectedRentPlan("");
  setManualRoomRent("");
  setAvailableRooms([]);
  setRoomSearchError("");

  setOpenRentDialog(true);
};


const activeRoomType = rentDialogRoomType || row.roomType || "";

const normalizedRoomType = String(activeRoomType)
  .trim()
  .toLowerCase();

const matchingRoomType = (hostelRoomDTOs || []).find(
  (item) =>
    String(item?.roomType || "").trim().toLowerCase() ===
    normalizedRoomType
);

const filteredRooms = [
  ...new Set(
    String(matchingRoomType?.roomNumber || "")
      .split(",")
      .map((number) => number.trim())
      .filter(Boolean)
  ),
];

const rentDialogRoom = matchingRoomType;

const rentPlans = [
  {
    label: "2–3 Hours",
    value: "2_TO_3_HOURS",
    price: rentDialogRoom?.price2To3Hours,
  },
  {
    label: "4–6 Hours",
    value: "4_TO_6_HOURS",
    price: rentDialogRoom?.price4To6Hours,
  },
  {
    label: "6–12 Hours",
    value: "6_TO_12_HOURS",
    price: rentDialogRoom?.price6To12Hours,
  },
  {
    label: "Daily",
    value: "DAILY",
    price: rentDialogRoom?.dailyPrice,
  },
  {
    label: "Monthly",
    value: "MONTHLY",
    price: rentDialogRoom?.monthlyPrice,
  },
];
/* =====================================================
   SAVE MAIN BILL
===================================================== */
const handleSaveMainBill = () => {
  /* =====================================================
     DATE-ONLY EDIT VALIDATION
     Do not validate Final Bill or other billing fields
  ===================================================== */

  if (isDateOnlyEdit) {
    if (
      !row.checkIn ||
      !row.checkOut ||
      !dayjs(row.checkIn).isValid() ||
      !dayjs(row.checkOut).isValid() ||
      !dayjs(row.checkOut).isAfter(dayjs(row.checkIn))
    ) {
      setRows((prevRows) =>
        prevRows.map((item, i) =>
          i === index
            ? {
                ...item,
                errorMsg:
                  "Please enter valid Check-In and Check-Out dates. Check-Out must be after Check-In.",
                successMsg: "",
              }
            : item
        )
      );

      return;
    }

    handleSaveRow(index);
    return;
  }

  /* =====================================================
     FINAL BILL VALIDATION
  ===================================================== */

  const hasFinalBill =
    row.finalBill !== undefined &&
    row.finalBill !== null &&
    row.finalBill !== "" &&
    Number(row.finalBill) > 0;

  if (!hasFinalBill) {
    setRows((prevRows) =>
      prevRows.map((item, i) =>
        i === index
          ? {
              ...item,
              errorMsg: "Final Bill is required.",
              successMsg: "",
            }
          : item
      )
    );

    return;
  }

  /* =====================================================
     STAY DATE VALIDATION
     Required for stay and both services
  ===================================================== */

  if (
    hasStay &&
    (!row.checkIn || !row.checkOut)
  ) {
    setRows((prevRows) =>
      prevRows.map((item, i) =>
        i === index
          ? {
              ...item,
              errorMsg:
                "Check-In and Check-Out are required for Stay service.",
              successMsg: "",
            }
          : item
      )
    );

    return;
  }

  /* =====================================================
     SAVE
  ===================================================== */

  handleSaveRow(index);
};

  return (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <>
      <Paper
        elevation={0}
        sx={{
          p: {
            xs: 1.25,
            sm: 2,
            md: 2.5,
          },

          mb: 2.5,

          borderRadius: 3,

          backgroundColor: "#fff",

          border:
            "1px solid #e2e8f0",

          boxShadow:
            "0 4px 18px rgba(15, 23, 42, 0.06)",

          transition:
            "box-shadow 0.2s ease",

          "&:hover": {
            boxShadow:
              "0 6px 24px rgba(15, 23, 42, 0.09)",
          },
        }}
      >
        {/* =================================================
            HEADER
        ================================================= */}

        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          justifyContent="space-between"
          alignItems={{
            xs: "flex-start",
            sm: "center",
          }}
          sx={{
            mb: 2,
            pb: 1.5,
            borderBottom:
              "1px solid #edf0f4",
            gap: 1.5,
          }}
        >
          <Box>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <Typography
                variant="subtitle1"
                fontWeight={700}
                sx={{
                  color: "#1e293b",
                }}
              >
                Bill Entry #{index + 1}
              </Typography>

              {row.isEditing && (
                <Chip
                  label={
                    row.isSaved
                      ? "Editing"
                      : "New Entry"
                  }
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{
                    height: 23,
                    fontWeight: 700,
                  }}
                />
              )}
            </Stack>

            {row.name && (
              <Typography
                variant="caption"
                sx={{
                  color: "#64748b",
                }}
              >
                {row.name}
              </Typography>
            )}
          </Box>

          <Chip
            label={statusLabel(
              row.paymentStatus
            )}
            color={statusColor(
              row.paymentStatus
            )}
            size="small"
            sx={{
              fontWeight: 700,
              borderRadius: 2,
              height: 28,
            }}
          />
        </Stack>

        {/* =================================================
            FORM
        ================================================= */}

        <Grid
          container
          spacing={{
            xs: 1.25,
            sm: 1.5,
          }}
          sx={{
            "& .MuiTextField-root, & .MuiFormControl-root":
              {
                minWidth: 0,
                width: "100%",
              },

            "& .MuiInputBase-root": {
              minHeight: 48,
              borderRadius: 1.5,
              backgroundColor: "#fff",
            },

            "& .MuiInputBase-input": {
              fontSize: {
                xs: "0.95rem",
                sm: "0.95rem",
              },
              fontWeight: 500,
              color: "#263238",
              lineHeight: 1.4,
            },

            "& .MuiInputLabel-root": {
              fontSize: {
                xs: "0.88rem",
                sm: "0.875rem",
              },
              fontWeight: 500,
              color: "#54636f",
            },

            "& .MuiInputLabel-root.Mui-focused":
              {
                fontWeight: 600,
              },

            "& .MuiSelect-select": {
              fontSize: {
                xs: "0.95rem",
                sm: "0.95rem",
              },
              fontWeight: 500,
              color: "#263238",
              minHeight:
                "48px !important",
              display: "flex",
              alignItems: "center",
              boxSizing:
                "border-box",
            },

            "& .MuiInputBase-input.Mui-disabled":
              {
                WebkitTextFillColor:
                  "#37474f",
                color: "#37474f",
                opacity: 1,
                fontWeight: 500,
              },

            "& .MuiSelect-select.Mui-disabled":
              {
                WebkitTextFillColor:
                  "#37474f",
                color: "#37474f",
                opacity: 1,
              },

            "& .MuiInputBase-input[readonly]":
              {
                color: "#263238",
                opacity: 1,
              },

            "& input[type='number']":
              {
                fontVariantNumeric:
                  "tabular-nums",
                textAlign: "right",
              },

            "& input[type='datetime-local']":
              {
                fontVariantNumeric:
                  "tabular-nums",
              },

            "& .MuiFormHelperText-root":
              {
                marginLeft: 1,
                marginTop: 0.5,
                fontSize:
                  "0.75rem",
                fontWeight: 500,
              },
          }}
        >
          {/* =================================================
              DATE
          ================================================= */}

          <Grid
            item
            xs={12}
            sm={6}
            md={2}
          >
            <TextField
              type="date"
              fullWidth
              size="medium"
              label="Date"
              InputLabelProps={{
                shrink: true,
              }}
              value={
                row.date || ""
              }
              disabled={
                !canEditOtherFields
              }
              onChange={(e) =>
                handleChange(
                  index,
                  "date",
                  e.target.value
                )
              }
            />
          </Grid>

          {/* =================================================
              SERVICE
          ================================================= */}

          <Grid
            item
            xs={12}
            sm={6}
            md={2}
          >
            <FormControl
              fullWidth
              size="medium"
            >
              <InputLabel>
                Service
              </InputLabel>

              <Select
                value={
                  row.serviceType ||
                  ""
                }
                label="Service"
                disabled={
                  !canEditOtherFields
                }
                onChange={(e) =>
                  handleChange(
                    index,
                    "serviceType",
                    e.target.value
                  )
                }
              >
                <MenuItem value="mess">
                  Mess Only
                </MenuItem>

                <MenuItem value="stay">
                  Stay Only
                </MenuItem>

                <MenuItem value="both">
                  Stay + Mess
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* =================================================
              ROOM
          ================================================= */}

          {hasStay && (
            <>
              {/* ROOM TYPE */}

              <Grid
                item
                xs={6}
                sm={3}
                md={1.75}
              >
                <FormControl
                  fullWidth
                  size="medium"
                >
                  <InputLabel>
                    Room Type
                  </InputLabel>

                  <Select
                    value={
                      row.roomType ||
                      ""
                    }
                    label="Room Type"
                    disabled={
                      !canEditOtherFields
                    }
                    onChange={(e) =>
  handleRoomTypeChange(e.target.value)
}
                  >
                    {roomTypes.map(
                      (rt) => (
                        <MenuItem
                          key={rt.id}
                          value={
                            rt.roomType
                          }
                        >
                          {rt.roomType}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>

              {/* ROOM RENT */}

              <Grid item xs={6} sm={3} md={1.5}>
  <TextField
    type="number"
    fullWidth
    size="medium"
    label="Room Rent"
    value={row.roomRent ?? ""}
    disabled={!canEditOtherFields}
    onChange={(e) =>
      handleChange(index, "roomRent", e.target.value)
    }
  />
</Grid>

       {/* ROOM NUMBER DROPDOWN */}

<Grid item xs={6} sm={3} md={1.75}>
  <FormControl fullWidth size="medium">
    <InputLabel id={`room-number-label-${index}`}>
      Room No.
    </InputLabel>

    <Select
      labelId={`room-number-label-${index}`}
      label="Room No."
      value={row.roomNumber || ""}
      disabled={!canEditOtherFields}
      onChange={(e) => {
  const roomNumber = e.target.value;

  handleChange(index, "roomNumber", roomNumber);
  setSelectedRoomNumber(roomNumber);
}}
    >
      {filteredRooms.map((roomNumber) => (
        <MenuItem key={roomNumber} value={roomNumber}>
          {roomNumber}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>

{/* SEARCH AVAILABLE ROOMS BUTTON */}

<Grid item xs={6} sm={3} md={1.25}>
  <Button
    fullWidth
    variant="outlined"
    color="primary"
    onClick={handleSearchAvailableRooms}
    disabled={
      !canEditOtherFields ||
      !row.roomType ||
      !row.checkIn ||
      !row.checkOut ||
      loadingRooms
    }
    startIcon={
      loadingRooms ? (
        <CircularProgress size={16} />
      ) : (
        <SearchIcon />
      )
    }
    sx={{
      minHeight: 48,
      borderRadius: 1.5,
      fontWeight: 600,
      whiteSpace: "nowrap",
      px: 1,
    }}
  >
    {loadingRooms ? "Searching..." : "Search"}
  </Button>
</Grid>

              {/* STAY RENT */}

              <Grid
                item
                xs={6}
                sm={3}
                md={1.5}
              >
                <TextField
                  type="number"
                  fullWidth
                  size="medium"
                  label="Stay Rent"
                  value={
                    row.stayRate ??
                    ""
                  }
                  disabled={
                    !canEditOtherFields
                  }
                  onChange={(e) =>
                    handleChange(
                      index,
                      "stayRate",
                      e.target.value
                    )
                  }
                />
              </Grid>

              {/* MICRO STAY DURATION */}

              {isMicroStay &&
                row.microStayCategory && (
                  <Grid
                    item
                    xs={6}
                    sm={3}
                    md={1.5}
                  >
                    <TextField
                      fullWidth
                      size="medium"
                      label="Duration"
                      value={
                        row.stayDurationHours !=
                        null
                          ? `${row.stayDurationHours} hrs`
                          : ""
                      }
                      InputProps={{
                        readOnly:
                          true,
                      }}
                    />
                  </Grid>
                )}

              {/* MICRO STAY SLAB */}

              {isMicroStay &&
                row.microStayCategory && (
                  <Grid
                    item
                    xs={6}
                    sm={3}
                    md={1.5}
                  >
                    <TextField
                      fullWidth
                      size="medium"
                      label="Stay Slab"
                      value={
                        row.microStayCategory ||
                        ""
                      }
                      InputProps={{
                        readOnly:
                          true,
                      }}
                    />
                  </Grid>
                )}
            </>
          )}

   {/* =================================================
    DATES / CHECK-IN / CHECK-OUT
================================================= */}

{(hasMess || hasStay) && (
  <>
    {/* =================================================
        FROM DATE / CHECK-IN
    ================================================= */}

  {/* CHECK-IN */}
<Grid item xs={12} sm={6} md={3}>
  <DateTimePicker
  label={hasStay ? "Check-In" : "From Date"}
  value={row.checkIn ? dayjs(row.checkIn) : null}
  disabled={!canEditDates}
  ampm={false}
  format="DD/MM/YYYY HH:mm"
  views={["year", "month", "day", "hours", "minutes"]}
  onChange={(newValue) =>
    handleChange(
      index,
      "checkIn",
      newValue?.isValid()
        ? newValue.format("YYYY-MM-DDTHH:mm")
        : ""
    )
  }
  slotProps={{
    textField: {
      fullWidth: true,
      size: "medium",
      required: hasStay,
    },
  }}
/>
</Grid>

{/* CHECK-OUT */}
<Grid item xs={12} sm={6} md={3}>
  <DateTimePicker
  label={hasStay ? "Check-Out" : "To Date"}
  value={row.checkOut ? dayjs(row.checkOut) : null}
 disabled={!canEditDates}
  ampm={false}
  format="DD/MM/YYYY HH:mm"
  views={["year", "month", "day", "hours", "minutes"]}
  onChange={(newValue) =>
    handleChange(
      index,
      "checkOut",
      newValue?.isValid()
        ? newValue.format("YYYY-MM-DDTHH:mm")
        : ""
    )
  }
  slotProps={{
    textField: {
      fullWidth: true,
      size: "medium",
      required: hasStay,
    },
  }}
/>
</Grid>

    {/* =================================================
        DAYS
    ================================================= */}

    <Grid
      item
      xs={6}
      sm={3}
      md={1}
    >
      <TextField
        type="number"
        fullWidth
        size="medium"
        label={
          hasStay
            ? "Stay Days"
            : "Mess Days"
        }
        value={row.stayDays ?? ""}
        disabled={
         !canEditOtherFields ||
          (hasStay && isMicroStay)
        }
        onChange={(e) =>
          handleChange(
            index,
            "stayDays",
            e.target.value
          )
        }
      />
    </Grid>
  </>
)}
          {/* =================================================
              CUSTOMER
          ================================================= */}

          <Grid
            item
            xs={12}
            sm={6}
            md={2.5}
          >
            <TextField
              fullWidth
              size="medium"
              label="Customer Name"
              value={
                row.name || ""
              }
              disabled={
                !canEditOtherFields
              }
              onChange={(e) =>
                handleChange(
                  index,
                  "name",
                  e.target.value
                )
              }
            />
          </Grid>

          {/* MOBILE */}

          <Grid
            item
            xs={12}
            sm={6}
            md={2}
          >
            <TextField
              fullWidth
              size="medium"
              label="Mobile Number"
              value={
                row.customerMobileNumber ||
                ""
              }
              disabled={
                !canEditOtherFields
              }
              inputProps={{
                maxLength: 10,
                inputMode:
                  "numeric",
              }}
              onChange={(e) => {
                const value =
                  e.target.value.replace(
                    /\D/g,
                    ""
                  );

                handleChange(
                  index,
                  "customerMobileNumber",
                  value
                );
              }}
            />
          </Grid>

          {/* ADDRESS */}

          <Grid
            item
            xs={12}
            sm={6}
            md={3}
          >
            <TextField
              fullWidth
              size="medium"
              label="Address"
              value={
                row.address || ""
              }
              disabled={
                !canEditOtherFields
              }
              onChange={(e) =>
                handleChange(
                  index,
                  "address",
                  e.target.value
                )
              }
            />
          </Grid>

          {/* COUNT */}

          <Grid
            item
            xs={6}
            sm={3}
            md={1}
          >
            <TextField
              type="number"
              fullWidth
              size="medium"
              label="Count"
              value={
                row.count ?? 1
              }
              disabled={
                !canEditOtherFields
              }
              onChange={(e) =>
                handleChange(
                  index,
                  "count",
                  e.target.value
                )
              }
            />
          </Grid>

          {/* MESS CHARGE */}

          {hasMess && (
            <Grid
              item
              xs={6}
              sm={3}
              md={1.5}
            >
              <TextField
                type="number"
                fullWidth
                size="medium"
                label="Mess Charge"
                value={
                  row.rate ??
                  ""
                }
                disabled={
                 !canEditOtherFields
                }
                onChange={(e) =>
                  handleChange(
                    index,
                    "rate",
                    e.target.value
                  )
                }
              />
            </Grid>
          )}

          {/* DISCOUNT */}

          <Grid
            item
            xs={6}
            sm={3}
            md={1.5}
          >
            <TextField
              type="number"
              fullWidth
              size="medium"
              label="Discount"
              value={
                row.discount ??
                ""
              }
              disabled={
                !canEditOtherFields
              }
              onChange={(e) =>
                handleChange(
                  index,
                  "discount",
                  e.target.value
                )
              }
            />
          </Grid>

          {/* MESS TOTAL */}

          {hasMess && (
            <Grid
              item
              xs={6}
              sm={3}
              md={1.75}
            >
              <TextField
                fullWidth
                size="medium"
                label="Mess Total"
                value={Number(
                  row.messTotal ??
                    0
                )}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          )}

          {/* TOTAL */}

          <Grid
            item
            xs={6}
            sm={3}
            md={1.75}
          >
            <TextField
              fullWidth
              size="medium"
              label="Total"
              value={
                calculatedTotal
              }
              InputProps={{
                readOnly: true,
              }}
              sx={{
                "& .MuiInputBase-input":
                  {
                    fontWeight: 700,
                  },
              }}
            />
          </Grid>

          {/* FINAL BILL */}

          <Grid
            item
            xs={6}
            sm={3}
            md={1.75}
          >
            <TextField
              type="number"
              fullWidth
              size="medium"
              label="Final Bill"
              required
              value={
                finalBill
              }
              disabled={
                !canEditOtherFields
              }
              error={
                row.isEditing &&
                isFinalBillEmpty
              }
              helperText={
                row.isEditing &&
                isFinalBillEmpty
                  ? "Final Bill is required"
                  : ""
              }
              onChange={(e) =>
                handleChange(
                  index,
                  "finalBill",
                  e.target.value
                )
              }
              InputProps={{
                endAdornment:
                  isManualFinalBill ? (
                    <Chip
                      label="Manual"
                      size="small"
                      color="warning"
                      sx={{
                        height: 24,
                        fontSize: 11,
                        fontWeight: 700,
                      }}
                    />
                  ) : null,
              }}
            />
          </Grid>

          {/* RECEIVED */}

          <Grid
            item
            xs={6}
            sm={3}
            md={1.75}
          >
            <TextField
              type="number"
              fullWidth
              size="medium"
              label="Received"
              value={
                row.received ??
                ""
              }
              disabled={
                !canEditOtherFields
              }
              onChange={(e) =>
                handleChange(
                  index,
                  "received",
                  e.target.value
                )
              }
            />
          </Grid>

          {/* BALANCE */}

          <Grid
            item
            xs={6}
            sm={3}
            md={1.75}
          >
            <TextField
              fullWidth
              size="medium"
              label="Balance"
              value={Number(
                row.balance ??
                  0
              )}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        </Grid>

        {/* =================================================
            MICRO STAY INFO
        ================================================= */}

        {hasStay &&
          isMicroStay &&
          row.microStayCategory && (
            <Alert
              severity="info"
              sx={{
                mt: 2,
                borderRadius: 2,
                fontWeight: 600,
              }}
            >
              Micro Stay:{" "}
              <strong>
                {row.microStayCategory}
              </strong>

              {row.stayDurationHours !=
                null && (
                <>
                  {" "}
                  — Duration:{" "}
                  <strong>
                    {
                      row.stayDurationHours
                    }{" "}
                    hours
                  </strong>
                </>
              )}
            </Alert>
          )}

        {/* =================================================
            ERRORS
        ================================================= */}

        {row.errorMsg && (
          <Alert
            severity="error"
            sx={{
              mt: 2,
              borderRadius: 2,
              fontWeight: 600,
            }}
          >
            {row.errorMsg}
          </Alert>
        )}

        {/* =================================================
            SUCCESS
        ================================================= */}

        {row.successMsg && (
          <Alert
            severity="success"
            sx={{
              mt: 2,
              borderRadius: 2,
            }}
          >
            {row.successMsg}
          </Alert>
        )}

        {/* =================================================
            DAILY MESS DETAILS
        ================================================= */}

        {hasMess && (
          <Paper
            elevation={0}
            sx={{
              mt: 2,
              p: 1.5,
              borderRadius: 2.5,
              border:
                "1px solid #dbeafe",
              background:
                "linear-gradient(135deg,#f8fbff,#eff6ff)",
            }}
          >
            <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              spacing={1.5}
              alignItems={{
                xs: "stretch",
                sm: "center",
              }}
              justifyContent="space-between"
            >
              <Box>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                >
                  <RestaurantIcon
                    fontSize="small"
                    color="primary"
                  />

                  <Typography
                    variant="body2"
                    fontWeight={700}
                  >
                    Daily Mess Details
                  </Typography>

                  {row
                    .dailyMessDetails
                    ?.length > 0 && (
                    <Chip
                      size="small"
                      color="success"
                      label={`${row.dailyMessDetails.length} days`}
                      sx={{
                        height: 23,
                        fontWeight: 700,
                      }}
                    />
                  )}
                </Stack>

                <Typography
                  variant="caption"
                  color="text.secondary"
                >
                  Manage breakfast,
                  lunch, dinner and
                  extra items.
                </Typography>
              </Box>

              <Button
                variant={
                  row.dailyMessDetails
                    ?.length > 0
                    ? "contained"
                    : "outlined"
                }
                color="primary"
                size="small"
                startIcon={
                  <RestaurantIcon />
                }
                onClick={
                  handleOpenMessDetails
                }
                disabled={
                  loadingMessDetails
                }
                sx={{
                  borderRadius: 2,
                  fontWeight: 700,
                  minWidth: {
                    xs: 0,
                    sm: 180,
                  },
                  width: {
                    xs: "100%",
                    sm: "auto",
                  },
                  minHeight: 42,
                }}
              >
                {loadingMessDetails
                  ? "Loading..."
                  : row
                      .dailyMessDetails
                      ?.length > 0
                  ? row.isEditing
                    ? "Edit Mess Details"
                    : "View Mess Details"
                  : row.isEditing
                  ? "Add Mess Details"
                  : "View Mess Details"}
              </Button>
            </Stack>
          </Paper>
        )}

        {/* =================================================
            GUEST DETAILS (STAY / STAY + MESS)
        ================================================= */}

        {hasStay && (
          <Paper
            elevation={0}
            sx={{
              mt: 2,
              p: 1.5,
              borderRadius: 2.5,
              border: "1px solid #d1fae5",
              background: "linear-gradient(135deg,#f0fdf4,#ecfdf5)",
            }}
          >
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.5}
              alignItems={{ xs: "stretch", sm: "center" }}
              justifyContent="space-between"
            >
              <Box>
                <Typography variant="body2" fontWeight={700}>
                  Guest Details
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Add each staying guest's name, age and phone number.
                </Typography>
              </Box>
            <Button
  variant="text"
  onClick={handleOpenGuestDetails}
  disabled={loadingGuestDetails}
  startIcon={
    loadingGuestDetails ? (
      <CircularProgress size={16} />
    ) : undefined
  }
  sx={{
    alignSelf: { xs: "flex-start", sm: "center" },
    fontWeight: 700,
    textDecoration: "underline",
    minHeight: 40,
  }}
>
  {loadingGuestDetails
    ? "Loading..."
    : row.guestDetails?.length
    ? row.isEditing
      ? "Edit Guest Details"
      : "View Guest Details"
    : row.isEditing
    ? "Add Guest Details"
    : "View Guest Details"}
</Button>
                
            </Stack>
            {row.guestDetails?.length > 0 && (
              <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                {row.guestDetails.length} guest{row.guestDetails.length === 1 ? "" : "s"} added
              </Typography>
            )}
          </Paper>
        )}

        {/* =================================================
            ACTIONS
        ================================================= */}

        <Paper
          elevation={0}
          sx={{
            mt: 2,
            p: {
              xs: 1,
              sm: 1.5,
            },
            borderRadius: 2.5,
            background:
              "#f8fafc",
            border:
              "1px solid #edf0f4",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns:
                {
                  xs:
                    "repeat(2, minmax(0, 1fr))",
                  sm:
                    "repeat(5, minmax(0, 1fr))",
                },
              gap: {
                xs: 0.75,
                sm: 1,
              },
              width: "100%",
            }}
          >
            {/* SAVE */}

            <Button
              variant="contained"
              color="success"
              size="small"
              startIcon={
                <SaveIcon />
              }
              onClick={
                handleSaveMainBill
              }
              disabled={!canSave}
              sx={{
                gridColumn: {
                  xs: "1 / -1",
                  sm: "auto",
                },
                minWidth: 0,
                width: "100%",
                minHeight: 42,
                borderRadius: 2,
                fontWeight: 700,
                boxShadow: "none",
              }}
            >
              {row.isSaved
                ? "Save Changes"
                : "Save"}
            </Button>

            {/* EDIT */}

            <Button
              variant="outlined"
              size="small"
              startIcon={
                <EditIcon />
              }
             disabled={
  isReadOnly ||
  row.isEditing ||
  rows.some(
    (r, i) =>
      i !== index &&
      r.isEditing
  )
}
              onClick={
                handleEdit
              }
              sx={{
                minWidth: 0,
                width: "100%",
                minHeight: 42,
                borderRadius: 2,
                fontWeight: 600,
              }}
            >
              Edit
            </Button>

            {/* PRINT */}
{showPrintActions && (
            <Button
              variant="outlined"
              size="small"
              startIcon={
                <PrintIcon />
              }
              onClick={() =>
                handlePrint(row)
              }
              sx={{
                minWidth: 0,
                width: "100%",
                minHeight: 42,
                borderRadius: 2,
                fontWeight: 600,
              }}
            >
              Print
            </Button>
			)}

            {/* WHATSAPP */}
{showWhatsAppActions && (
            <Button
              variant="outlined"
              color="success"
              size="small"
              startIcon={
                <WhatsAppIcon />
              }
              onClick={() =>
                handleWhatsApp(row)
              }
              sx={{
                minWidth: 0,
                width: "100%",
                minHeight: 42,
                borderRadius: 2,
                fontWeight: 600,
              }}
            >
              WhatsApp
            </Button>
)}
            {/* DELETE */}
{showDeleteActions && (
            <Button
              variant="outlined"
              color="error"
              size="small"
              startIcon={
                <DeleteOutlineIcon />
              }
              disabled={
                row.isEditing
              }
              onClick={() => {
                setRowToDelete(row);
                setOpenDeleteDialog(
                  true
                );
              }}
              sx={{
                minWidth: 0,
                width: "100%",
                minHeight: 42,
                borderRadius: 2,
                fontWeight: 600,
              }}
            >
              Delete
            </Button>
			)}
          </Box>
        </Paper>

        {/* =================================================
            REMARKS
        ================================================= */}

        <Box
          sx={{
            mt: 2.5,
            pt: 2,
            borderTop:
              "1px solid #edf0f4",
          }}
        >
          <Typography
            variant="subtitle2"
            fontWeight={700}
            sx={{
              mb: 1,
              color: "#334155",
            }}
          >
            Notes
          </Typography>

          <TextField
            fullWidth
            size="small"
            label="Remarks"
            value={
              row.remarks || ""
            }
            disabled={
              !canEditOtherFields
            }
            onChange={(e) =>
              handleChange(
                index,
                "remarks",
                e.target.value
              )
            }
          />
        </Box>
      </Paper>

      {/* =================================================
          GUEST DETAILS DIALOG
      ================================================= */}
      <Dialog
        open={openGuestDetails}
        onClose={() => setOpenGuestDetails(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Guest Details</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            {guestDetails.map((guest, guestIndex) => (
              <Paper
                key={guestIndex}
                variant="outlined"
                sx={{ p: 2, borderRadius: 2 }}
              >
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
                  <Typography fontWeight={700}>Guest {guestIndex + 1}</Typography>
                  {guestDetails.length > 1 && (
                    <Button
                      color="error"
                      size="small"
                      disabled={!canEditOtherFields}
                      onClick={() => setGuestDetails((prev) => prev.filter((_, i) => i !== guestIndex))}
                    >
                      Remove
                    </Button>
                  )}
                </Stack>
                <Grid container spacing={1.5}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Guest Name"
                      value={guest.guestName}
                      disabled={!canEditOtherFields}
                      onChange={(e) => setGuestDetails((prev) => prev.map((item, i) => i === guestIndex ? { ...item, guestName: e.target.value } : item))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      fullWidth
                      required
                      type="number"
                      label="Age"
                      value={guest.age}
                      disabled={!canEditOtherFields}
                      inputProps={{ min: 0, max: 120 }}
                      onChange={(e) => setGuestDetails((prev) => prev.map((item, i) => i === guestIndex ? { ...item, age: e.target.value } : item))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      required
                      label="Phone Number"
                      value={guest.phoneNumber}
                      disabled={!canEditOtherFields}
                      inputProps={{ maxLength: 10, inputMode: "numeric" }}
                      onChange={(e) => {
                        const phoneNumber = e.target.value.replace(/\D/g, "").slice(0, 10);
                        setGuestDetails((prev) => prev.map((item, i) => i === guestIndex ? { ...item, phoneNumber } : item));
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            ))}

            {guestDetailsError && <Alert severity="error">{guestDetailsError}</Alert>}

            {canEditOtherFields && (
  <Button
    variant="outlined"
    onClick={() =>
      setGuestDetails((prev) => [
        ...prev,
        { guestName: "", age: "", phoneNumber: "" },
      ])
    }
  >
    + Add Another Guest
  </Button>
)}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenGuestDetails(false)}>Close</Button>
          {canEditOtherFields && (
  <Button
    variant="contained"
    onClick={handleSaveGuestDetails}
  >
    Save Guest Details
  </Button>
)}
        </DialogActions>
      </Dialog>

      {/* =================================================
          DAILY MESS DIALOG
      ================================================= */}

      <DailyMessDetailsDialog
        open={openMessDetails}
        onClose={() =>
          setOpenMessDetails(false)
        }
        row={row}
        onSaveDetails={
          handleSaveMessDetails
        }
        isEditing={canEditOtherFields}
      />
	  
	  
	  
	  <Dialog
  open={openRoomSearch}
  onClose={() => {
    if (!loadingRooms) setOpenRoomSearch(false);
  }}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>Available Rooms</DialogTitle>

  <DialogContent dividers>
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ mb: 2 }}
    >
      {row.checkIn
        ? dayjs(row.checkIn).format("DD/MM/YYYY HH:mm")
        : ""}
      {" — "}
      {row.checkOut
        ? dayjs(row.checkOut).format("DD/MM/YYYY HH:mm")
        : ""}
    </Typography>

    {loadingRooms ? (
      <Stack alignItems="center" spacing={1} sx={{ py: 4 }}>
        <CircularProgress size={28} />
        <Typography variant="body2">
          Checking room availability...
        </Typography>
      </Stack>
    ) : roomSearchError ? (
      <Alert severity="info">{roomSearchError}</Alert>
    ) : availableRooms.length === 0 ? (
      <Alert severity="info">
        No available rooms found for the selected dates and room type.
      </Alert>
    ) : (
      <Stack spacing={1}>
        {availableRooms.map((room, i) => {
          const roomNumber = String(
            room.roomNumber ?? room.roomNo ?? room.name ?? ""
          ).trim();

          const count = Number(room.availableRoomCount ?? 0);

          return (
            <Paper
              key={room.id ?? room.roomId ?? i}
              variant="outlined"
              sx={{
                p: 1.5,
                borderRadius: 2,
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
              >
                <Box>
                  <Typography fontWeight={700}>
                    {roomNumber
                      ? `Room ${roomNumber}`
                      : `${count} rooms available`}
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    {room.roomType ?? room.type ?? ""}
                  </Typography>

                  {!roomNumber && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                    >
                      Individual room numbers were not provided by the server.
                    </Typography>
                  )}
                </Box>

                {roomNumber ? (
                  <Button
                    size="small"
                    variant="outlined"
               
onClick={() => {
  handleChange(index, "roomNumber", roomNumber);
  setSelectedRoomNumber(roomNumber);
  setOpenRoomSearch(false);
}}
                  >
                    Select
                  </Button>
                ) : (
                  <Button
                    size="small"
                    variant="outlined"
                    disabled
                  >
                    Select
                  </Button>
                )}
              </Stack>
            </Paper>
          );
        })}
      </Stack>
    )}
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => setOpenRoomSearch(false)}
      disabled={loadingRooms}
    >
      Close
    </Button>
  </DialogActions>
</Dialog>


<Dialog
  open={openRentDialog}
  onClose={() => setOpenRentDialog(false)}
  fullWidth
  maxWidth="xs"
>
  <DialogTitle>
    Select Room Rent — {rentDialogRoomType || row.roomType || ""}
  </DialogTitle>

  <DialogContent dividers>
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ mb: 2 }}
    >
      {selectedRoomNumber
        ? `Room Number: ${selectedRoomNumber}`
        : "Select a room number if needed."}
    </Typography>
    <RadioGroup
      value={selectedRentPlan}
      onChange={(e) => {
        const planValue = e.target.value;
        const selectedPlan = rentPlans.find(
          (plan) => plan.value === planValue
        );

        setSelectedRentPlan(planValue);
        setManualRoomRent(
          selectedPlan?.price != null
            ? String(selectedPlan.price)
            : ""
        );
      }}
    >
      {rentPlans.map((plan) => {
        const hasPrice =
          plan.price !== null &&
          plan.price !== undefined &&
          plan.price !== "" &&
          Number.isFinite(Number(plan.price)) &&
          Number(plan.price) >= 0;

        return (
          <FormControlLabel
            key={plan.value}
            value={plan.value}
            disabled={!hasPrice}
            control={<Radio />}
            label={
              <Box>
                <Typography fontWeight={600}>
                  {plan.label}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  {hasPrice
                    ? `₹${Number(plan.price).toLocaleString("en-IN")}`
                    : "Price not configured"}
                </Typography>
              </Box>
            }
            sx={{
              mx: 0,
              mb: 1,
              p: 1,
              width: "100%",
              border: "1px solid #e2e8f0",
              borderRadius: 2,
            }}
          />
        );
      })}
    </RadioGroup>

    <TextField
      fullWidth
      type="number"
      label="Room Rent (₹)"
      margin="normal"
      value={manualRoomRent}
      onChange={(e) => {
        setManualRoomRent(e.target.value);
        setSelectedRentPlan("");
      }}
      inputProps={{ min: 0, step: "any" }}
      helperText="Select a rent plan or enter a custom amount."
    />
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenRentDialog(false)}>
      Cancel
    </Button>

    <Button
      variant="contained"
      disabled={
        manualRoomRent === "" ||
        !Number.isFinite(Number(manualRoomRent)) ||
        Number(manualRoomRent) < 0
      }
      onClick={() => {
        const rent = Number(manualRoomRent);

        handleChange(index, "roomRent", rent);
        handleChange(index, "rentPlan", selectedRentPlan || "CUSTOM");

        setOpenRentDialog(false);
      }}
    >
      Apply Rent
    </Button>
  </DialogActions>
</Dialog>
    </>
  </LocalizationProvider>
);
};

export default GuestEntryCard;